// Route `api` cho thực thể `quote` (H-DT): `/v1/quotes` (TblQuotation, SQL 016) → `Quote` của màn Báo giá.
// Worker chỉ trả đầu báo giá, KHÔNG tiền: giá bán / hiệu lực / tàu / margin để rỗng hoặc 0 (margin không bao giờ lấy từ API ngoài quyền money).
import type { ApiRoute } from '@hana/data';
import type { Quote, QuoteKind, QuoteStatus } from './types';

type Row = Record<string, unknown>;
const str = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

const STATUS: Record<string, QuoteStatus> = {
  draft: 'Nháp', 'nháp': 'Nháp',
  sent: 'Đã gửi', 'đã gửi': 'Đã gửi',
  accepted: 'Khách chấp nhận', 'khách chấp nhận': 'Khách chấp nhận',
  expired: 'Hết hạn', 'hết hạn': 'Hết hạn',
  converted: 'Đã thành Job', won: 'Đã thành Job', 'đã thành job': 'Đã thành Job',
};

export function quoteKindOf(shipment: string, cargo: string): QuoteKind {
  if (shipment.toUpperCase() === 'AIR') return 'Air';
  if (cargo.toUpperCase() === 'RF') return 'Reefer';
  return cargo.toUpperCase() === 'LCL' || shipment.toUpperCase() === 'LCL' ? 'Sea LCL' : 'Sea FCL';
}

export function quoteFromApi(r: Row): Quote {
  return {
    id: str(r.Ref),
    customer: str(r.ShortName) || str(r.CustomerName),
    contact: str(r.PIC),
    route: str(r.RouteCode),
    transit: '',
    kind: quoteKindOf(str(r.TypeShipment), str(r.TypeCargo)),
    qty: '',
    carrier: '',
    vessel: '',
    validDays: 0,
    price: 0,
    unit: str(r.Currency),
    margin: 0,
    sale: str(r.SaleLine),
    status: STATUS[str(r.Status).toLowerCase()] ?? 'Nháp',
    live: false,
    under: false,
    madeDays: 0,
  };
}

const items = (json: unknown): Row[] => {
  const list = (json as { items?: unknown } | null)?.items;
  return Array.isArray(list) ? (list as Row[]) : [];
};

export const quoteApiRoute: ApiRoute<Quote> = {
  path: '/api/v1/quotes',
  query: (q) => {
    const limit = q.limit && q.limit > 0 ? q.limit : 50;
    return { q: q.q?.trim(), limit, page: Math.floor((q.offset ?? 0) / limit) + 1 };
  },
  parse: (json) => ({ items: items(json).map(quoteFromApi), hasMore: (json as { hasMore?: boolean } | null)?.hasMore === true }),
  getPath: (id) => `/api/v1/quotes/${encodeURIComponent(id)}`,
  parseOne: (json) => (json && typeof json === 'object' && 'Ref' in json ? quoteFromApi(json as Row) : null),
};
